export default __webpack_public_path__ + "static/media/arrow-white.235e4df5.svg";